const avatarColors = [
  "#F44336",
  "#E91E63",
  "#9C27B0",
  "#673AB7",
  "#3F51B5",
  "#2196F3",
  "#03A6F4",
  "#00BCD4",
  "#009688",
  "#4CAF50",
  "#8BC34A",
  "#CDDC39",
  "#FFC107",
  "#FF9800",
  "#FF5722",
  "#795548",
  "#607D8B"
];

type UserAvatarProps = {
  name?: string | null;
  imageUrl?: string | null;
  size?: "sm" | "md" | "lg";
};

export function UserAvatar({ name = "?", imageUrl, size = "md" }: UserAvatarProps) {
  const displayName = name?.trim() || "?";
  const initials = getInitials(displayName);
  const background = avatarColors[Math.abs(hashString(displayName)) % avatarColors.length];

  if (imageUrl) {
    return <img className={`user-avatar user-avatar-${size}`} src={imageUrl} alt="" loading="lazy" />;
  }

  return (
    <span className={`user-avatar user-avatar-${size} user-avatar-fallback`} style={{ backgroundColor: background }}>
      {initials}
    </span>
  );
}

export function displayUserName(user: { nickname?: string; email?: string } | null | undefined, fallback = "Forum user") {
  return user?.nickname || user?.email || fallback;
}

function getInitials(name: string) {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return (name[0] || "?").toUpperCase();
}

function hashString(value: string) {
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(index);
    hash |= 0;
  }
  return hash;
}
